import React from 'react'
import { useLocation,useNavigate,useParams } from 'react-router-dom';
import { useState } from 'react';
import {RadioButton} from 'coaz-ui';
import client from '../client';

const PaymentOptions = () => {
    const [selected,setSelected] = useState(null);
    const location = useLocation();
    const state = location.state;
    const {request,errorMessage} = client;
    const {currentUserId,receivableId,criteriaId} = useParams();
    const path = useLocation().pathname;
    const navigate = useNavigate();

    const onSelect = (option) => {
        setSelected(option);
    }

    const options = [
        {
            id:'main_acc',
            name:'Main Account'
        },
        {
            id:'mobile',
            name:'Mobile Money'
        },
        {
            id:'card',
            name:'Card'
        }
    ]

    const close = () => {
        navigate(-1)
    }

    const onContinue = async (e) => {
        if(!currentUserId || !receivableId || !criteriaId) {
            return;
        }
        let user = null;
        await request('GET','current',null,null,true) 
        .then((response) => {
            if(response.content && response.content.user) {
                user = response.content.user;
            }
        })
        let tariff = null;
        await request('GET','tariff',null,{receivableId:receivableId,criteriaId:criteriaId},true) 
        .then((response) => {
            if(response.content) {
                tariff = response.content;
            }
        })
        if(!user || !tariff) {
            return;
        }
        if(selected && selected.id === 'main_acc') {
            navigate('/_payment',{state:{user:user,tariff:tariff,sponsor:state.sponsor?state.sponsor:''}});
        } else if(selected && selected.id === 'mobile') {
            window.location.href = `/_mobile_payment?userId=${user.id}&receivableId=${tariff.receivableId}&criteriaId=${tariff.criteriaId}&sponsor=${encodeURIComponent(state.sponsor?state.sponsor:'')}`;
            /* navigate('/mobile_payment',{state:{parentPath:path,user:user,tariff:tariff,sponsor:state.sponsor?state.sponsor:''}}); */
        }
    }

  return (
    <div className="flex items-center justify-center w-full h-full overflow-hidden">
            <div
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        onContinue(e);
                    }
                }}
                style={{ backdropFilter: "blur(20px)" }}
                className="flex flex-col w-[95%] sm:w-[640px] h-[420px] bg-[rgba(255,255,255,.5)] items-center rounded-xl shadow-md overflow-hidden"
            >
            <span className='w-full h-fit font-helveticaNeueRegular text-sm text-[rgb(150,150,150)]'>Payment Options</span>
            <div className='flex flex-col space-y-4 w-fit h-fit'>
            {options.map((option,i) => <RadioButton key={i} radioButton={option} selected={selected} onSelect={onSelect}/>)}
            </div>
            <div className='flex flex-row items-center justify-center space-x-4 w-fit h-fit shrink-0'>
                <button 
                    onClick={e => {
                        e.preventDefault();
                        onContinue(e);
                    }} 
                    disabled={!selected}
                    className={`flex shrink-0 w-32 h-8 rounded-lg items-center justify-center ${selected?'bg-[rgb(0,175,240)] hover:bg-[rgba(0,175,240,.7)]':'bg-gray-300'}  text-white`}>
                    Continue
                </button>
                <button onClick={close} 
                    className='flex shrink-0 w-32 h-8 rounded-lg items-center justify-center bg-[rgb(0,175,240)] hover:bg-[rgba(0,175,240,.7)] text-white'>
                    Cancel
                </button>
            </div>
        </div>
    </div>
  )
}

export default PaymentOptions